document.addEventListener('DOMContentLoaded', function() {
    const epworth = document.querySelector('[data-epworth]');

    if (!epworth) {
        return;
    }

    const questions = Array.from(epworth.querySelectorAll('[data-epworth-question]'));
    const summary = epworth.querySelector('[data-epworth-summary]');
    const scoreNode = epworth.querySelector('[data-epworth-score]');
    const titleNode = epworth.querySelector('[data-epworth-title]');
    const descriptionNode = epworth.querySelector('[data-epworth-description]');

    const getResult = function(score) {
        if (score > 18) {
            return {
                level: 'high',
                title: 'Ciężka senność',
                description: 'Wynik powyżej 18 punktów. Wskazana jest konsultacja lekarska.'
            };
        }

        if (score >= 15) {
            return {
                level: 'moderate',
                title: 'Umiarkowana senność',
                description: 'Wynik od 15 do 18 punktów.'
            };
        }

        if (score >= 11) {
            return {
                level: 'mild',
                title: 'Łagodna senność',
                description: 'Wynik od 11 do 14 punktów.'
            };
        }

        return {
            level: 'normal',
            title: 'Wynik prawidłowy',
            description: 'Wynik od 0 do 10 punktów.'
        };
    };

    const renderSummary = function() {
        const unansweredQuestion = questions.find(function(question) {
            return typeof question.dataset.epworthValue === 'undefined';
        });

        if (unansweredQuestion) {
            summary.hidden = true;
            return;
        }

        const score = questions.reduce(function(total, question) {
            return total + Number.parseInt(question.dataset.epworthValue, 10);
        }, 0);
        const result = getResult(score);

        summary.hidden = false;
    summary.dataset.epworthLevel = result.level;
        scoreNode.textContent = score + '/24 punktów';
        titleNode.textContent = result.title;
        descriptionNode.textContent = result.description;
    };

    questions.forEach(function(question) {
        const answers = question.querySelectorAll('[data-epworth-answer]');

        answers.forEach(function(answerButton) {
            answerButton.addEventListener('click', function() {
                const wasComplete = !summary.hidden;
                question.dataset.epworthValue = answerButton.dataset.epworthAnswer;

                answers.forEach(function(button) {
                    const isActive = button === answerButton;
                    button.classList.toggle('is-active', isActive);
                    button.setAttribute('aria-pressed', String(isActive));
                });

                renderSummary();

                if (!summary.hidden && !wasComplete) {
                    summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    summary.focus({ preventScroll: true });
                }
            });
        });
    });

    renderSummary();
});